import { useParams } from "react-router-dom";
import { useCategoryList, useContent } from "../use-fetch-cosmicjs-state";
import { BreadcrumbsProps } from "@graffer-inc/console-design-kit";
import React from "react";
import { useTitle } from "../../../../utils/use-title";

const MAX_PARENT_BREADCRUMBS_DEPTH = 4 as const;

export const useDetailController = () => {
  const { objectSlug } = useParams<{ objectSlug: string }>();
  const { content, isLoading } = useContent(objectSlug);
  const { categoryList } = useCategoryList();

  useTitle(content?.title);

  const productId = content?.metadata?.product?.id ?? "";

  const parentContents = React.useMemo(() => {
    if (!content) return [];
    const breadcrumbs = [];
    let currentContent = content;
    let depth = 0;

    while (
      currentContent?.metadata?.parent &&
      depth < MAX_PARENT_BREADCRUMBS_DEPTH
    ) {
      breadcrumbs.unshift({
        title: currentContent.metadata.parent.title,
        to: `/help/contents/${currentContent.metadata.parent.slug}`,
      });
      currentContent = currentContent.metadata.parent;
      depth++;
    }

    return breadcrumbs;
  }, [content]);

  const breadcrumbsProps: BreadcrumbsProps = {
    list: content
      ? [
          { title: "トップ", to: "/help" },
          {
            title: content.metadata?.product?.title || "",
            to: `/help/${content.metadata?.product?.id}`,
          },
          ...parentContents,
          { title: content.title || "", to: `/help/contents/${content.title}` },
        ]
      : [],
    anchor: ({ href = "", children, ...props }) => (
      <a {...props} href={href}>
        {children}
      </a>
    ),
  };

  return {
    content,
    categoryList,
    productId,
    breadcrumbsProps,
    isLoading,
  };
};
